module.exports = __webpack_public_path__ + "static/media/user-circle-blue.eea09466.svg";